/** Shared registration payload, validation, and error mapping (public + admin). */

export const INITIAL_REGISTER_FORM = {
  fullName: "",
  email: "",
  password: "",
  companyName: "",
  industry: "",
  businessEmail: "",
  businessAddress: "",
};

const firstError = (value) => (Array.isArray(value) ? value[0] : value);

export const buildRegisterPayload = (formData) => ({
  email: formData.email.trim(),
  full_name: formData.fullName.trim(),
  password: formData.password,
  password2: formData.password,
  company: {
    company_name: formData.companyName.trim(),
    company_email: formData.businessEmail.trim(),
    address: formData.businessAddress.trim(),
    ceo: formData.industry.trim(),
  },
});

export const mapRegisterErrors = (data) => {
  if (!data || typeof data !== "object") {
    return {
      form: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    };
  }

  const fieldErrors = {};

  if (data.email) fieldErrors.email = firstError(data.email);
  if (data.full_name) fieldErrors.fullName = firstError(data.full_name);
  if (data.password) fieldErrors.password = firstError(data.password);
  if (data.password2) fieldErrors.password = firstError(data.password2);

  if (data.company) {
    if (typeof data.company === "string") {
      fieldErrors.form = data.company;
    } else {
      if (data.company.company_name) {
        fieldErrors.companyName = firstError(data.company.company_name);
      }
      if (data.company.company_email) {
        fieldErrors.businessEmail = firstError(data.company.company_email);
      }
      if (data.company.address) {
        fieldErrors.businessAddress = firstError(data.company.address);
      }
      if (data.company.ceo) fieldErrors.industry = firstError(data.company.ceo);
    }
  }

  if (data.detail) fieldErrors.form = firstError(data.detail);
  if (data.non_field_errors) fieldErrors.form = firstError(data.non_field_errors);

  if (!fieldErrors.form && Object.keys(fieldErrors).length === 0) {
    fieldErrors.form =
      "Registrierung fehlgeschlagen. Bitte prüfen Sie Ihre Angaben.";
  }

  return fieldErrors;
};

export const validateRegisterStepOne = (formData) => {
  const errors = {};

  if (!formData.fullName.trim()) {
    errors.fullName = "Bitte geben Sie den vollständigen Namen ein.";
  }

  if (!formData.email.trim()) {
    errors.email = "Bitte geben Sie die E-Mail-Adresse ein.";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
  }

  if (!formData.password.trim()) {
    errors.password = "Bitte geben Sie ein Passwort ein.";
  } else if (formData.password.length < 12) {
    errors.password = "Das Passwort muss mindestens 12 Zeichen lang sein.";
  }

  return errors;
};

export const validateRegisterStepTwo = (formData) => {
  const errors = {};

  if (!formData.companyName.trim()) {
    errors.companyName = "Bitte geben Sie den Firmennamen ein.";
  }

  if (!formData.industry.trim()) {
    errors.industry = "Bitte geben Sie die Branche ein.";
  }

  if (!formData.businessEmail.trim()) {
    errors.businessEmail = "Bitte geben Sie die geschäftliche E-Mail ein.";
  } else if (!/\S+@\S+\.\S+/.test(formData.businessEmail)) {
    errors.businessEmail =
      "Bitte geben Sie eine gültige geschäftliche E-Mail ein.";
  }

  if (!formData.businessAddress.trim()) {
    errors.businessAddress = "Bitte geben Sie die Geschäftsadresse ein.";
  }

  return errors;
};
